/* eslint-disable import/prefer-default-export */
import getSafe from '../getSafe';
import { SUPPORTED_TARGETS } from './constants';
/*
  Restaurant Properties:
  {
    categoryNames, deliveryFee, deliveryStatus, deliveryTime, images: { default }, isEditions, isPlaceholder, minimumOrderValue, name, newlyAdded, offer, placeholderClass, priceCategory, ratingCount, ratingPercent, links: { self: { href } }
  }
*/

export const buildRestaurant = ({ images, links, ...otherProps }) => ({
  imageUrl: getSafe(() => images.default),
  url: getSafe(() => links.self.href),
  ...otherProps,
});

export const getTargetURL = (target) => {
  if ([SUPPORTED_TARGETS.RESTAURANT].includes(target.typeName)) {
    return getSafe(() => target.restaurant.links.self.href);
  }
  if ([SUPPORTED_TARGETS.MENU_ITEM].includes(target.typeName)) {
    return getSafe(() => target.links.href);
  }

  return '';
};
